import React, { Fragment, useEffect, useMemo, useState } from "react";
import { getDominio } from "./getDominio";
import { gestaoApi } from "../api";

const defRedes = {
  facebook: {
    url: "https://www.facebook.com/bolichebrasil",
    icon: "fa-facebook fab",
  },
  twitter: {
    url: "https://x.com/bolichebrasil",
    icon: "fa-twitter fab",
  },
  instagram: {
    url: "https://www.instagram.com/bolichebrasil",
    icon: "fa-instagram fab",
  },
  youtube: {
    url: "https://www.youtube.com/c/BolicheBrasil",
    icon: "fa-youtube fab",
  },
};

function RedesSociais() {
  const dominio = getDominio();
  const [federacao, setFederacao] = useState({});
  useEffect(() => {
    async function getFederacoes() {
      if (!dominio?.conf?.id || dominio.conf.id === 1) {
        setFederacao({});
        return;
      }
      await gestaoApi
        .get(`estabelecimento/${dominio.conf.id}`)
        .then((response) => {
          if (response.data) {
            setFederacao(response.data);
          }
        })
        .catch(() => {
          setFederacao({});
        });
    }
    getFederacoes();
  }, [dominio.conf]);

  const links = useMemo(() => {
    if (dominio?.conf?.id === 1) {
      return defRedes;
    }
    if (federacao && federacao.id) {
      return {
        facebook: {
          url: federacao.perfil_facebook?.includes("https")
            ? federacao.perfil_facebook
            : federacao.perfil_facebook
            ? `https://www.facebook.com/${federacao.perfil_facebook}`
            : null,
          icon: defRedes.facebook.icon,
        },
        instagram: {
          url: federacao.perfil_instagram?.includes("https")
            ? federacao.perfil_instagram
            : federacao.perfil_instagram
            ? `https://www.instagram.com/${federacao.perfil_instagram}`
            : null,
          icon: defRedes.instagram.icon,
        },
        youtube: {
          url: federacao.perfil_youtube?.includes("https")
            ? federacao.perfil_youtube
            : federacao.perfil_youtube
            ? `https://www.youtube.com/${federacao.perfil_youtube}`
            : null,
          icon: defRedes.youtube.icon,
        },
        twitter: {
          url: federacao.perfil_twitter?.includes("https")
            ? federacao.perfil_twitter
            : federacao.perfil_twitter
            ? `https://x.com/${federacao.perfil_twitter}`
            : null,
          icon: defRedes.twitter.icon,
        },
      };
    }
    return {};
  }, [federacao, dominio]);

  return (
    <Fragment>
      {Object.entries(links).map((item, key) => (
        <a
          key={key}
          href={item[1].url}
          target="_blank"
          rel="noreferrer"
          className={item[1].url ? "social-icon" : "d-none"}
        >
          <i className={item[1].icon}></i>
        </a>
      ))}
    </Fragment>
  );
}

export default RedesSociais;
